import React from "react";
import Avatar from "./Avatar";
import PerformanceBadge from "./PerformanceBadge";
import { Building2, Briefcase } from "lucide-react";

// Pick the best display title from the spreadsheet values.
// Priority: job_title (from import sheet) → staff_classification → role_title → access_role.
function displayTitle(staff) {
  return staff.job_title || staff.staff_classification || staff.role_title || staff.access_role || "—";
}

export default function StaffCard({ staff, score, band, ytdAverage }) {
  if (!staff) return null;
  return (
    <div className="nv-card p-5 flex gap-4" data-testid="staff-identity-card">
      <Avatar name={staff.full_name} gender={staff.gender} src={staff.profile_image} size="xl" />
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-h3 truncate" data-testid="staff-card-name">{staff.full_name || "Missing Staff Link"}</h3>
            <p className="text-sm text-slate-500 flex items-center gap-1.5 mt-0.5">
              <Briefcase size={13} /> {displayTitle(staff)}
            </p>
          </div>
          {staff.employment_status === "former" ? (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-rose-50 text-rose-700 border border-rose-200">Former</span>
          ) : staff.active_status === false ? (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">Inactive</span>
          ) : (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700">Active</span>
          )}
        </div>
        <div className="grid grid-cols-2 gap-x-6 gap-y-1.5 mt-3 text-sm">
          <div className="flex items-center gap-1.5 text-slate-600"><Building2 size={13} className="text-slate-400" /><span className="font-medium">{staff.home || staff.assigned_home || "—"}</span></div>
          <div className="text-slate-500"><span className="text-small-caps">Gender</span> <span className="ml-1">{staff.gender || "—"}</span></div>
          <div className="text-slate-500"><span className="text-small-caps">Access</span> <span className="ml-1">{staff.access_role || "Staff"}</span></div>
          <div className="text-slate-500"><span className="text-small-caps">YTD Avg</span> <span className="ml-1 font-semibold text-slate-800">{ytdAverage?.toFixed?.(2) ?? "—"}</span></div>
        </div>
        {(score != null || band) && (
          <div className="mt-3 flex items-center gap-2">
            <PerformanceBadge band={band} score={typeof score === "number" ? score : undefined} />
          </div>
        )}
      </div>
    </div>
  );
}
